import React from 'react';
import { Link } from 'react-router-dom';
import { maps } from '../data/maps';

const HomePage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <p className="text-gray-300 text-lg">Select a map to view smoke and nade lineups</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {Object.values(maps)
          .filter(map => map.CT.length > 0 || map.T.length > 0) // Only show maps with lineups
          .map((map) => (
          <Link
            key={map.name}
            to={`/map/${map.name}`}
            className="group"
          >
            <div className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-700 hover:border-yellow-400">
              <div className="h-48 bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center relative overflow-hidden">
                {map.previewImage ? (
                  <img 
                    src={map.previewImage} 
                    alt={map.displayName}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const fallback = target.nextElementSibling as HTMLElement;
                      if (fallback) {
                        fallback.classList.remove('hidden');
                      }
                    }}
                  />
                ) : null}
                <div className={`text-center ${map.previewImage ? 'hidden' : ''}`}>
                  <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-gray-900 font-bold text-xl">
                      {map.displayName.split(' ')[0][0]}
                    </span>
                  </div>
                  <h2 className="text-xl font-semibold text-white group-hover:text-yellow-400 transition-colors">
                    {map.displayName}
                  </h2>
                </div>
                {/* Map name overlay for preview images */}
                {map.previewImage && (
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end">
                    <div className="p-4 w-full">
                      <h2 className="text-xl font-semibold text-white group-hover:text-yellow-400 transition-colors">
                        {map.displayName}
                      </h2>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HomePage; 